import { useEffect, useState } from "react";
import { GoogleMap, Marker, DirectionsRenderer } from "@react-google-maps/api";
import axiosInstance from "../api/axiosInstance";
import { useParams } from "react-router-dom";

const containerStyle = {
  width: "100%",
  height: "80vh",
};

export default function OrderTrackingPage() {
  const { orderId } = useParams();

  const [deliveryBoyLocation, setDeliveryBoyLocation] = useState(null);
  const [directions, setDirections] = useState(null);

  // 🔹 TEMP (later fetch from backend order)
  const pickupLocation = { lat: 28.6139, lng: 77.2090 }; // shop / hospital
  const customerLocation = { lat: 28.5355, lng: 77.3910 }; // customer

  // 1️⃣ Fetch delivery boy live location
  const fetchDeliveryLocation = async () => {
    try {
      const res = await axiosInstance.get(
        `/orders/${orderId}/delivery-location/`
      );

      setDeliveryBoyLocation({
        lat: res.data.lat,
        lng: res.data.lng,
      });
    } catch (err) {
      console.error("Failed to fetch delivery location");
    }
  };

  // 2️⃣ Poll every 5 seconds
  useEffect(() => {
    fetchDeliveryLocation();
    const interval = setInterval(fetchDeliveryLocation, 5000);
    return () => clearInterval(interval);
  }, []);

  // 3️⃣ Draw route (pickup → customer)
  useEffect(() => {
    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin: pickupLocation,
        destination: customerLocation,
        travelMode: "DRIVING",
      },
      (result, status) => {
        if (status === "OK") {
          setDirections(result);
        }
      }
    );
  }, []);

  if (!deliveryBoyLocation) {
    return <p>Loading live tracking...</p>;
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={deliveryBoyLocation}
      zoom={15}
    >
      {/* 🚴 Delivery Boy */}
      <Marker position={deliveryBoyLocation} />

      {/* 🛣️ Route */}
      {directions && <DirectionsRenderer directions={directions} />}
    </GoogleMap>
  );
}
